import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import ConfirmCancel from './ConfirmCancel'
import Header from './Header'
import Middle from './Middle'
import Footer from './Footer'
import { formatTimestamp } from '../time-tools'
import css from './styles.css'

const SelectedBlast = (props) => {
  const {
    blast, isCancelConfirmationOpen, isCancellable,
    closeSelectedBlastModal, openCancellationDialog,
    affirmCancellation, denyCancellation
  } = props
  const messageType = blast.isEmail ? 'Email' : 'Text'
  const formattedScheduledFor = blast.scheduledFor ?
    formatTimestamp('selectedBlast', blast.scheduledFor) :
    'cancelled'

  return (
    <div className={css.wrapper}>
      <ConfirmCancel
        isOpen={isCancelConfirmationOpen}
        affirmCancellation={affirmCancellation}
        denyCancellation={denyCancellation}
      />
      <div className={css.modal}>
        <Header
          showCancelButton={isCancellable}
          openCancellationDialog={openCancellationDialog}
          closeSelectedBlastModal={closeSelectedBlastModal}
          messageType={messageType}
        />
        <Middle
          isCancelled={blast.isCancelled}
          scheduledFor={formattedScheduledFor}
        />
        <Footer
          sent={blast.counts.sent}
          pending={blast.counts.pending}
          total={blast.counts.total}
        />
      </div>
    </div>
  )
}

SelectedBlast.propTypes = {
  blast: PropTypes.shape({
    isEmail: PropTypes.bool.isRequired,
    isCancelled: PropTypes.bool.isRequired,
    scheduledFor: PropTypes.string.isRequired,
    counts: PropTypes.shape({
      sent: PropTypes.number.isRequired,
      pending: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  isCancelConfirmationOpen: PropTypes.bool.isRequired,
  isCancellable: PropTypes.bool.isRequired,
  openCancellationDialog: PropTypes.func.isRequired,
  closeSelectedBlastModal: PropTypes.func.isRequired,
  affirmCancellation: PropTypes.func.isRequired,
  denyCancellation: PropTypes.func.isRequired,
}

export default SelectedBlast



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/SelectedBlast/index.js